import { render, staticRenderFns } from "./ReferralModule.vue?vue&type=template&id=2dd420b0"
import script from "./ReferralModule.vue?vue&type=script&lang=js"
export * from "./ReferralModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports